import { KeyboardEvent } from 'react';
import { TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';

import { KEYS } from '~/const';

interface ITextFieldEnter extends StandardTextFieldProps {
	onEnter: (event: KeyboardEvent) => void;
}

export default function TextFieldEnter({
	onEnter = () => {},
	...props
}: ITextFieldEnter) {
	function onKeyUp(event: KeyboardEvent) {
		if (event.key === KEYS.ENTER) {
			onEnter(event);
		}
	}

	return <TextField
		size="small"
		onKeyUp={onKeyUp}
		inputProps={{
			autoComplete: "off",
		}}
		{ ...props }
	/>;
}
